module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-5-buyback_f66c8b8455d66edc72ca4d5ac8fc737c.png";